/**
 * The old channelpartners.* hosts are being retired in favor of new hosts
 * under partners.*.adobe.com/channelpartners.
 * If this app is ever reached under one of the old hosts (existing bookmarks,
 * old links, a Community proxy still routing to the old domain), rewrite the
 * browser to the equivalent new host instead of leaving users on a dead domain.
 */
const OLD_TO_NEW_CHANNEL_PARTNERS_HOST = {
  "channelpartners.stage2.adobe.com": "partners.stage.adobe.com/channelpartners",
  "channelpartners.adobe.com": "partners.adobe.com/channelpartners",
};

/**
 * @returns {boolean} true if a redirect was triggered. Callers should skip
 * rendering the rest of the app in that case — `window.location.replace`
 * only *schedules* the navigation, it doesn't stop the current script, so
 * anything rendered after this call (IMS init, profile fetch, etc.) would
 * still run once, needlessly, before the browser actually navigates away.
 */
export const handleChannelPartnersUrlRedirection = () => {
  const { hostname, pathname, search, hash } = window.location;
  const newHostAndPath = OLD_TO_NEW_CHANNEL_PARTNERS_HOST[hostname];

  if (newHostAndPath) {
    window.location.replace(`https://${newHostAndPath}${pathname}${search}${hash}`);
    return true;
  }
  return false;
};
